import { render } from "./NegociosBeneficios.vue?vue&type=template&id=622267d8&scoped=true"
import script from "./NegociosBeneficios.vue?vue&type=script&lang=js"
export * from "./NegociosBeneficios.vue?vue&type=script&lang=js"

import "./NegociosBeneficios.vue?vue&type=style&index=0&id=622267d8&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622267d8"]])

export default __exports__